/* unplugin-vue-components disabled */import script from "./ShareBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareBtn.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__